module.exports = __webpack_public_path__ + "static/media/translater.0d483005.png";